export default __webpack_public_path__ + "static/media/feedback.8fd0d5c7.svg";